const EMPTY_VALUE = '-';

export function formatNumber(
  value: number | undefined,
  maximumFractionDigits = 2,
) {
  if (value == null) {
    return EMPTY_VALUE;
  }
  return new Intl.NumberFormat(undefined, { maximumFractionDigits }).format(
    value,
  );
}

export function formatPercentage(fractionalValue: number | undefined) {
  return fractionalValue != null
    ? `${Math.round(fractionalValue * 100)}%`
    : EMPTY_VALUE;
}

const SIZES = ['', 'k', 'M', 'G', 'T'] as const;

export function formatPower(
  value: number | undefined,
  sizeExponent: typeof SIZES[number],
): { value: string; unit: string } {
  const baseUnitSuffix = 'W';

  if (value === undefined) return { value: '', unit: '' };
  if (value === 0)
    return { value: '0', unit: `${sizeExponent}${baseUnitSuffix}` };

  let factor = 1;
  let exp = -1;
  const valueInW = Math.abs(value) * 1000 ** SIZES.indexOf(sizeExponent);

  while (factor <= valueInW) {
    exp += 1;
    factor *= 1000;
  }
  return {
    value: formatNumber(valueInW / (factor / 1000), 2),
    unit: `${SIZES[exp] || ''}${baseUnitSuffix}`,
  };
}
